import { Component, Input, OnInit, signal, WritableSignal } from '@angular/core';

import { v4 as uuid } from 'uuid';
import { CustomIcon, IconLibrary, SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';

import { ButtonMode, ButtonTheme, IconPosition, ModalButtons } from '@fcom/ui-components/index';

@Component({
  selector: 'fin-mmb-hotel-legislation-modal',
  templateUrl: './hotel-legislation-modal.component.html',
  styleUrls: ['./hotel-legislation-modal.component.scss'],
  standalone: false,
})
export class MmbHotelLegislationModalComponent implements OnInit {
  readonly ButtonTheme = ButtonTheme;
  readonly ButtonMode = ButtonMode;
  readonly ModalButtons = ModalButtons;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly CustomIcon = CustomIcon;
  readonly IconPosition = IconPosition;
  readonly IconLibrary = IconLibrary;

  @Input({ required: true }) redirectUrl: string;
  @Input({ required: true }) isOpen: WritableSignal<boolean>;

  expandOpen = signal(false);
  id: string;

  ngOnInit(): void {
    this.id = uuid();
  }

  expandClick(): void {
    this.expandOpen.set(!this.expandOpen());
  }
}
